module.exports = __webpack_public_path__ + "media/customizations/regencyatwaterset/logo-new-2dd36f095b5937e0402f2d69fe4d0803.png";